/**
 * 订单配置信息，包含订单相关的配置
 */
// import * as Names from './statuses'
import flowConfigs from './flows'
// const ACTIONS = 'LIFEBANK_ACTIONS'
import store from '@/store'
/**
 * 获取默认的订单状态流程
 */
function getDefaultOrderFlow (isClosed = false, isTask = false) {
  let flows = isTask ? getTaskFlow().concat() : getOrderFlow().concat()

  // 是否是关闭订单的状态
  if (isClosed) {
    flows.forEach((e, index) => {
      if (e.name === 'COMPLETED') {
        flows.splice(index, 1)
      }
    })
  } else {
    flows.forEach((e, index) => {
      if (e.name === 'CLOSED') {
        flows.splice(index, 1)
      }
    })
  }
  // console.log(flows)
  return flows
}

function getActions (value) {
  let flows = getOrderFlow(value).concat()
  return flows
}

/**
 * 获取指定产品的订单流程，返回一个状态对象的有序数组
 * @param {*} name
 */
function getOrderFlow () {
  const name = 'LAB'
  for (let flowConfig of flowConfigs) {
    if (flowConfig.name === name) {
      return flowConfig.statuses
    }
  }
  return null
}
/**
 * 获取指定产品的订单流程，返回一个状态对象的有序数组
 * @param {*} name
 */
 function getTaskFlow () {
  const name = 'TASK'
  for (let flowConfig of flowConfigs) {
    if (flowConfig.name === name) {
      return flowConfig.statuses
    }
  }
  return null
}
/**
 * 根据传入的状态获取下一个状态
 * @param {*string} name
 * @param {*string} currentStatus
 */
function getNextOrderStatus (name, currentStatus, onlyStatusCode = false) {
  let orderflow = getOrderFlow(name)

  let currentStatusIndex = orderflow.findIndex(val => val.name === currentStatus)

  let nextStatusIndex = currentStatusIndex + 1
  if (nextStatusIndex > 0 && orderflow[nextStatusIndex]) {
    return onlyStatusCode ? orderflow[nextStatusIndex].name : orderflow[nextStatusIndex]
  } else {
    console.warn('未找到下一个状态信息')
    return ''
  }
}

/**
 * 查询订单流程是否结束
 * @param {*string} status
 */
function isComplete (name, currentStatus) {
  let orderflow = getOrderFlow(name)

  let currentStatusIndex = orderflow.findIndex(val => val.name === currentStatus)
  return orderflow.length === (currentStatusIndex + 1)
}
/**
 * 格式化订单状态用于order-list
 * example:"CREATED"=>'样本接收'
 * @param {*} value
 */
function formatOrderStatus (value) {
  const DEFAULT_FLOW = localStorage.getItem('focusView')
  let orderFlow = getDefaultOrderFlow(false, value)

  for (let item of orderFlow) {
    if (item.name === value) {
      let currentStatusIndex = orderFlow.findIndex(val => val.name === value)
      if (currentStatusIndex === orderFlow.length - 1) {
        return orderFlow[currentStatusIndex].description
      }
      // 直销商不显示数据质控状态
      if (DEFAULT_FLOW === 'DISTRIBUTION' && value === 'LAB_DNA_TESTED') {
        return orderFlow[currentStatusIndex].operation
      }
      return orderFlow[currentStatusIndex + 1].operation
    }
  }
  return ''
}
/**
 * 格式化订单状态
 * example:"LAB_SAMPLES_RECEIVED"=>'样本接收'
 * @param {*} value
 */
function formatTargetOrderStatus (value) {
  let orderFlow = getDefaultOrderFlow(false, value)
  console.log(value, orderFlow)
  for (let item of orderFlow) {
    if (item.name === value) {
      let currentStatusIndex = orderFlow.findIndex(val => val.name === value)
      if (currentStatusIndex === orderFlow.length - 1) {
        return orderFlow[currentStatusIndex].description
      }
      return orderFlow[currentStatusIndex].operation
    }
  }
  return ''
}

/**
 * 将订单操作转换为对应的描述
 * @param {*} value
 */
function formatOrderActions (value) {
  let actions = getActions(value)
  for (let item of actions) {
    if (item.name === value) {
      return item.description
    }
    if (value === 'NONE') {
      // NONE为完成状态，默认完成状态都是倒数第二个数据
      return actions[actions.length - 2].description
    }
  }
  return ''
}
/**
 * 根据状态判断是否可操作
 * @param {*} value
 */
function canNotOperation (nextStatus, order) {
  // 模拟实验室订单时都能操作
  if (order.mockAction === 'MOCK_LAB') {
    return false
  }
  if (order.mockAction === 'MOCK_ANALYSIS' && nextStatus === 'REPORT_CHECKED_1ST') {
    return false
  }
  const DEFAULT_FLOW = localStorage.getItem('focusView')
  // 专属实验室操作的状态
  let LabStatuses = getActions().filter(item => item.type === 'lab')
  let DistributionStatuses = getActions().filter(item => item.type === 'report')
  let canNOtOperation = DEFAULT_FLOW === 'LAB' ? DistributionStatuses : LabStatuses
  // console.log('==================nextStatus', nextStatus)
  // console.log('==================canNOtOperation', canNOtOperation)
  // console.log('==================nextStatus', nextStatus)
  // 国科大客户视角，也需要有操作步骤的
  // if (nextStatus) {
  //   if (canNOtOperation.map(e => e.name).includes(nextStatus)) {
  //     return true
  //   }
  // }
  return false
}
export default {
  // statuses以及getStatus暂时注释，需重新设计
  // statuses,
  // getStatus,
  getOrderFlow,
  getActions,
  getDefaultOrderFlow,
  getNextOrderStatus,
  isComplete,
  formatOrderStatus,
  formatOrderActions,
  formatTargetOrderStatus,
  canNotOperation
}
